import React, { Component } from 'react';

import applogomcg from '../../assets/img/brand/applogomcg.svg'

class pageHead extends Component {
  render() {
    return (
      <div className="pagehead">
        <img src={applogomcg} className="svg-applogo" alt="My CareGiver" />
      </div>
    )
  }
}

export default pageHead;


// WEBPACK FOOTER //
// ./src/views/Common/pageHead.js